/* eslint-disable solid/no-innerhtml */
import { type companyTaxonomy, wpQuery } from '@/lib/api/bapFormQuery'
import type { formTypes, updateHandler } from '@/web-components/BapFormApp/BapFormApp'
import type { getTermsSchema } from '@/web-components/BapFormApp/BapFormSchema'
import { createEffect, createMemo, createResource, createSignal, For, on, Show } from 'solid-js'
import { z } from 'zod'

type FormBapByCategoryProps = {
  terms: z.infer<typeof getTermsSchema> | undefined
  updateHandler: updateHandler
  companyTaxonomy: companyTaxonomy
  activeForm: formTypes | undefined
}
type fetchCompaniesByTermParams = {
  companyTaxonomy: companyTaxonomy
  termId: number
}
async function fetchCompaniesByTerm(params: fetchCompaniesByTermParams) {
  try {
    let query
    if (params.companyTaxonomy === 'yp_category') {
      query = {
        yp_category: params.termId,
      }
    }
    if (params.companyTaxonomy === 'bap_category') {
      query = {
        bap_category: params.termId,
      }
    }
    const response = await wpQuery.getCompaniesByTerm({
      query: { orderby: 'title', per_page: 100, order: 'asc', ...query },
      path: 'company',
    })

    // console.log(data)
    const ids = response.map((c) => {
      return c.id
    })
    return ids
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
  }
}

export function FormCompanyByCategory(props: FormBapByCategoryProps) {
  const [selectedCategory, setSelectedCategory] = createSignal<fetchCompaniesByTermParams>()

  const nonEmptyTerms = createMemo(() =>
    props.terms?.filter((t) => t.count > 0).sort((a, b) => a.name.localeCompare(b.name))
  )

  const [companies] = createResource(selectedCategory, fetchCompaniesByTerm)
  let companySelect: HTMLSelectElement
  createEffect(
    on(
      companies,
      (companies) => {
        if (!companies) return
        props.updateHandler({ companies: companies, form: 'category' })
      },
      { defer: true }
    )
  )

  createEffect(() => {
    if (props.activeForm === 'company') {
      companySelect.selectedIndex = 0
    }
  })
  return (
    <Show when={nonEmptyTerms()} keyed>
      {(terms) => (
        <Show when={terms.length > 0}>
          <form action="">
            <label class="mb-2 block font-bold" for="bap-companies">
              Search by Category
            </label>
            <div class="flex max-md:max-w-md max-md:flex-wrap">
              <div class="relative w-full max-md:w-full">
                <select
                  name="bap-categories"
                  id="bap-categories"
                  class="max-md:border-b-0 md:border-r-0 h-64 w-full max-w-full rounded-none border border-black p-16 pr-40 leading-130% max-md:w-full"
                  ref={(e) => (companySelect = e)}
                >
                  <option selected value="">
                    Select Category
                  </option>
                  <For each={terms}>
                    {(category) => <option value={category.id} innerHTML={category.name} />}
                  </For>
                </select>
              </div>
              <button
                class="btn w-full max-w-100 rounded-none"
                onClick={(e) => {
                  e.preventDefault()
                  if (companySelect.value) {
                    setSelectedCategory({
                      companyTaxonomy: props.companyTaxonomy,
                      termId: Number(companySelect.value),
                    })
                  }
                }}
              >
                GO
              </button>
            </div>
          </form>
        </Show>
      )}
    </Show>
  )
}
